import axios from "axios";
import { API_HOST } from "@/core/variables";
import { MessageChannel, MessageFeedback, MessageHistorySearchType } from "@/model";
import { getUtcZeroTime } from "@/util/dateUtil";


class MessageRepository {
    find = async (
        scenarioId: string,
        page: number,
        size: number,
        sort: "asc" | "desc",
        start_date: string,
        end_date: string,
        searchType: MessageHistorySearchType,
        condition?: string,
        channel?: MessageChannel,
        feedback?: MessageFeedback
    ) => {
        return axios
            .get(`${API_HOST}/scenario/${scenarioId}/messages/search`, {
                params: {
                    page: page,
                    size: size,
                    sort: sort,
                    start_date: getUtcZeroTime(start_date, "YYYY-MM-DD HH:mm:ss"),
                    end_date: getUtcZeroTime(end_date, "YYYY-MM-DD HH:mm:ss"),
                    search_type: searchType,
                    condition: condition,
                    channel: channel,
                    feedback: feedback
                }
            })
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    };

    findAll = async (
        scenarioId: string,
        start_date: string,
        end_date: string,
        searchType: MessageHistorySearchType,
        condition?: string,
        channel?: MessageChannel,
        feedback?: MessageFeedback
    ) => {
        return axios
            .get(`${API_HOST}/scenario/${scenarioId}/messages/search`, {
                params: {
                    start_date: getUtcZeroTime(start_date, "YYYY-MM-DD HH:mm:ss"),
                    end_date: getUtcZeroTime(end_date, "YYYY-MM-DD HH:mm:ss"),
                    search_type: searchType,
                    condition: condition,
                    channel: channel,
                    feedback: feedback
                }
            })
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    };
}

const messageRepository = new MessageRepository();

export default messageRepository; 
